export const DEFAULTS = {
    TITLE: "Advance Information",
    COLUMN_SIZE: "col-lg-4"
};

export const BUTTON_TEXTS = {
    FILTERS: "Filtros"
};
